var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransferenciaBancaria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.05 38.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00ccb3;}.cls-2{fill:#ff9811;}.cls-3{fill:#ff6243;}.cls-4{fill:#ffb655;}.cls-5{fill:#ffa733;}.cls-6{fill:#ee8700;}.cls-7{fill:#ffd422;}.cls-8{fill:#00b8a1;}.cls-9{fill:#f29010;}.cls-10{fill:#feda6f;}.cls-11{fill:#efbe43;}.cls-12{fill:#dd584d;}.cls-13{fill:#4da0dc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 19otros") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.46,0H38.24a.67.67,0,0,1,.67.67V8.72a.67.67,0,0,1-.67.67H19.46a.67.67,0,0,1-.67-.67v-8A.67.67,0,0,1,19.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.81,17.44v4H0v-4l11.41-2.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.75,18.11a1.35,1.35,0,1,1-1.34-1.34A1.34,1.34,0,0,1,12.75,18.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.7,21.47H18.11V33.55H4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2,21.47H4.7V33.55H2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.11,21.47H20.8V33.55H18.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.47,33.55H1.34v2.68H21.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M22.81,36.23H0v2.68H22.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M30.86,4.7a2,2,0,1,1-2-2A2,2,0,0,1,30.86,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.91,3.35V.67A.67.67,0,0,0,38.24,0H35.56A3.35,3.35,0,0,0,38.91,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M38.91,8.72V6a3.35,3.35,0,0,0-3.35,3.35h2.68A.67.67,0,0,0,38.91,8.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22.14,0H19.46a.67.67,0,0,0-.67.67V3.35A3.35,3.35,0,0,0,22.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M18.79,6V8.72a.67.67,0,0,0,.67.67h2.68A3.35,3.35,0,0,0,18.79,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M2,21.47H4.7v1.34H2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.11,21.47H20.8v1.34H18.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M4.7,21.47H18.11v1.34H4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.08,26.84H10.73a.67.67,0,0,1-.67-.67.68.68,0,0,1,.67-.68h1.35a.68.68,0,0,1,.67.68h1.34a2,2,0,0,0-2-2v-.67H10.73v.67a2,2,0,0,0,0,4h1.35a.67.67,0,0,1,0,1.34H10.73a.67.67,0,0,1-.67-.67H8.72a2,2,0,0,0,2,2v.67h1.35v-.67a2,2,0,0,0,0-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.82,30.19h1.35v1.34H24.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.51,30.19h1.34v1.34H27.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.19,30.19h1.34v1.34H30.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.19,27.51h1.34v1.34H30.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.19,24.82h1.34v1.35H30.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.19,22.14h1.34v1.34H30.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.19,19.46h1.34V20.8H30.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.19,16.77h1.34v1.34H30.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.19,14.09h1.34v1.34H30.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.19,11.41h1.34v1.34H30.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.43,3.35h1.34V4.7H15.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.75,3.35h1.34V4.7H12.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.06,3.35h1.35V4.7H10.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.06,6h1.35V7.38H10.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.06,8.72h1.35v1.34H10.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.06,11.41h1.35v1.34H10.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 41.11,
    cy: 34.73,
    r: 3.2,
    transform: "translate(-5.02 7.01) rotate(-9.19)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 41.11,
    cy: 34.73,
    r: 2.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M41,36.43v-.34a1.27,1.27,0,0,1-.41-.11.8.8,0,0,1-.28-.27.88.88,0,0,1-.13-.44l.34-.07a.72.72,0,0,0,.14.4.52.52,0,0,0,.34.21V34.73a1.62,1.62,0,0,1-.43-.16.67.67,0,0,1-.25-.25.75.75,0,0,1-.08-.37.73.73,0,0,1,.25-.58.86.86,0,0,1,.51-.18V33h.2v.17a.73.73,0,0,1,.46.17.75.75,0,0,1,.27.5l-.35.06a.59.59,0,0,0-.12-.31.47.47,0,0,0-.26-.14v1a1.85,1.85,0,0,1,.34.1.65.65,0,0,1,.25.17A.63.63,0,0,1,42,35a.94.94,0,0,1,.05.3.88.88,0,0,1-.22.59.86.86,0,0,1-.58.25v.34Zm0-3a.47.47,0,0,0-.31.16.41.41,0,0,0-.12.3.48.48,0,0,0,.1.29.57.57,0,0,0,.33.18Zm.2,2.34a.49.49,0,0,0,.32-.18.48.48,0,0,0,.13-.36.44.44,0,0,0-.09-.29.67.67,0,0,0-.36-.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 35.44,
    cy: 29.25,
    r: 2.05,
    transform: "translate(-4.22 6.04) rotate(-9.19)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 35.44,
    cy: 29.25,
    r: 1.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M35.39,30.34v-.21a.86.86,0,0,1-.27-.08.4.4,0,0,1-.17-.17.58.58,0,0,1-.09-.28l.22,0a.49.49,0,0,0,.09.25.3.3,0,0,0,.22.13v-.69a.86.86,0,0,1-.28-.1A.41.41,0,0,1,35,29a.56.56,0,0,1-.05-.23.46.46,0,0,1,.16-.37.5.5,0,0,1,.33-.12v-.1h.12v.1a.51.51,0,0,1,.3.11.48.48,0,0,1,.17.32l-.22,0a.37.37,0,0,0-.08-.2.39.39,0,0,0-.17-.09v.62l.22.07a.38.38,0,0,1,.16.11.31.31,0,0,1,.1.15.58.58,0,0,1,0,.19.5.5,0,0,1-.15.37.49.49,0,0,1-.37.16v.22Zm0-1.89a.32.32,0,0,0-.2.1.27.27,0,0,0-.08.19.29.29,0,0,0,.07.19.42.42,0,0,0,.21.12Zm.12,1.49a.27.27,0,0,0,.21-.11.31.31,0,0,0,.08-.23.36.36,0,0,0,0-.19.52.52,0,0,0-.24-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M44.16,29.21c-.3-1-1.6-4.25-5.3-3.58a3.54,3.54,0,0,1,3.36,3.58h-.84l1.84,2.18,1.83-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M31.84,34.63c.3,1,1.61,4.25,5.31,3.59a3.56,3.56,0,0,1-3.37-3.59h.84l-1.83-2.18L31,34.63Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferenciaBancaria);
export default __webpack_public_path__ + "static/media/transferencia-bancaria.37d004a919bbc919b8ae42fd1f38dc47.svg";
export { ForwardRef as ReactComponent };